import { render, staticRenderFns } from "./bottomButtons.vue?vue&type=template&id=1a7d3a1b&scoped=true"
import script from "./bottomButtons.vue?vue&type=script&lang=js"
export * from "./bottomButtons.vue?vue&type=script&lang=js"
import style0 from "./bottomButtons.vue?vue&type=style&index=0&id=1a7d3a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d3a1b",
  null
  
)

export default component.exports